import { normalize, schema } from 'normalizr'
import { AnyAction } from 'redux'

import requestStatuses from '@cinch/oxd-utils/request-status/src'

import * as types from '../types'

export const initialState = {
  fetchStatus: requestStatuses.INITIAL,
  searchResultsCount: 0,
  pageSize: 1,
  pageNumber: 1,
  byId: {},
  allIds: [],
}

export default function reducer(state = initialState, action: AnyAction) {
  const { type, payload } = action

  switch (type) {
    case types.VEHICLE_LISTING_REQUEST:
      return {
        ...state,
        fetchStatus: requestStatuses.PENDING,
      }
    case types.VEHICLE_LISTING_SUCCESS: {
      const response = payload as Cinch.DirectVehicleListingResponse
      const idAttribute = 'vehicleId'
      const vehicles = new schema.Entity('vehicles', undefined, { idAttribute })
      const responseSchema = new schema.Array(vehicles)
      const { entities } = normalize(response.vehicleListings, responseSchema)

      const byId = entities && entities.vehicles ? entities.vehicles : {}
      const allIds = response.vehicleListings.map((vehicleListing) => vehicleListing[idAttribute])

      const filters = response.filters

      return {
        ...state,
        fetchStatus: requestStatuses.SUCCESS,
        searchResultsCount: response.searchResultsCount,
        pageNumber: response.pageNumber,
        pageSize: response.pageSize,
        byId,
        allIds,
        filters,
      }
    }
    case types.VEHICLE_LISTING_FAILURE:
      return {
        ...state,
        fetchStatus: requestStatuses.ERROR,
        searchResultsCount: 0,
      }
    case types.VEHICLE_FILTERS_REQUEST:
      return {
        ...state,
      }
    case types.VEHICLE_FILTERS_SUCCESS: {
      const response = payload as Cinch.DirectVehicleListingResponse
      const { filters } = response

      return {
        ...state,
        filters,
      }
    }
    case types.VEHICLE_FILTERS_FAILURE:
      return {
        ...state,
      }
    default:
      return state
  }
}
